import type {
  HolderInformation,
  MemberInformation,
  CommonInformation,
  TravelerFieldData,
} from './TravelerCard.types'
import { formatDate } from '@qic/ui-components'

const DATE_MASK = 'd MMM yyyy'

const COMMON_FIELDS_INFORMATION: { [key in keyof CommonInformation]: TravelerFieldData } = {
  dateOfBirth: {
    translation: 'inbound_dob_date',
    format: (value: Date | null, locale = 'en') => {
      if (!value) return ''

      try {
        return formatDate(value, locale, DATE_MASK)
      } catch {
        return ''
      }
    },
  },
  nationality: {
    translation: 'inbound_nationality_nationality',
  },
  passportNumber: {
    translation: 'inbound_id_number',
  },
}

export const HOLDER_FIELDS_INFORMATION: { [key in keyof HolderInformation]: TravelerFieldData } = {
  ...COMMON_FIELDS_INFORMATION,
  email: {
    translation: 'outbound.travelers.email',
  },
  phone: {
    translation: 'outbound_travelers_add_mobile_number',
  },
  emiratesId: {
    translation: 'outbound.travelers.qatar_id',
  },
  civilIdExpiryDate: {
    translation: 'outbound.personal_info.qid_exp_date',
    format: (value: Date | null, locale = 'en') => {
      if (!value) return ''

      try {
        return formatDate(value, locale, DATE_MASK)
      } catch {
        return ''
      }
    },
  },
  gender: {
    translation: 'outbound.travelers.gender.label',
    format: (value: string, locale = 'en', t: any) =>
      value === '1' ? t('outbound.travelers.gender.male') : t('outbound.travelers.gender.female'),
  },
}

export const MEMBER_FIELDS_INFORMATION: { [key in keyof MemberInformation]: TravelerFieldData } = {
  ...COMMON_FIELDS_INFORMATION,
  relation: {
    translation: '',
  },
}

export const MEMBER_FIELDS: (keyof MemberInformation)[] = [
  'relation',
  'nationality',
  'passportNumber',
  'dateOfBirth',
]

export const HOLDER_FIELDS: (keyof HolderInformation)[] = [
  'nationality',
  'passportNumber',
  'dateOfBirth',
  'gender',
  'emiratesId',
  'civilIdExpiryDate',
  'email',
  'phone',
]
